import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/axiosAdvanced';


export const getPlaces = createAsyncThunk(
    'places/getPlaces',
    async (_, thunkAPI) => {
        try {
            const apiData = await apiClient.get('/get_places');
            console.log("Places", apiData)
            return apiData.data;
        } catch (error) {
            //console.log("Get places error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const saveZone = createAsyncThunk(
    'places/saveZone',
    async ({ zone_name, zone_color, zone_coords, zone_tags, zone_id }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/zone_save', {
                zone_name, zone_color, zone_coords, zone_tags, zone_id
            });
            //console.log("Zone saved", apiData.data);
            return apiData.data;
        } catch (error) {
            //console.log("Save Zone error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const saveMarker = createAsyncThunk(
    'places/saveMarker',
    async ({ marker_name, marker_color, marker_coords, marker_tags, marker_id, marker_desc }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/marker_save', {
                marker_name, marker_color, marker_coords, marker_tags, marker_id, marker_desc
            });
            //console.log("Marker saved", apiData.data);
            return apiData.data;
        } catch (error) {
            //console.log("Save Marker error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteZone = createAsyncThunk(
    'places/deleteZone',
    async (zone_id, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/zone_delete', { zone_id });
            //console.log("zone delted", apiData.data);
            return apiData.data;
        } catch (error) {
            //console.log("Delete zone error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteMarker = createAsyncThunk(
    'places/deleteMarker',
    async (marker_id, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/marker_delete', { marker_id });
            //console.log("marker delted", apiData.data);
            return apiData.data;
        } catch (error) {
            //console.log("Delete marker error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);